import { AxiosInstance } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v1/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v1/dongle';

export class DongleServiceV1 implements types.Handlers {
  private readonly endpoint = '/v1/dongles';

  constructor(private axios: AxiosInstance) {}
  async deleteDongle(params: types.DeleteDongleParameters): Promise<void> {
    await this.axios.delete<types.SkyMapConnectDongleRegistrationResponse>(
      `${this.endpoint}/${params.path.dongleId}`,
    );
  }

  async patchDongle(
    params: types.PatchDongleParameters,
  ): Promise<types.SkyMapConnectDonglePatchResponse> {
    const { data } = await this.axios.patch<types.SkyMapConnectDonglePatchResponse>(
      `${this.endpoint}/${params.path.dongleId}`,
      params.body,
    );
    return data;
  }

  async unregisterDongle(params: types.UnregisterDongleParameters): Promise<void> {
    await this.axios.delete<types.SkyMapConnectDongleRegistrationResponse>(
      `${this.endpoint}/${params.path.dongleId}/registration`,
      { data: params.body },
    );
  }

  async fetchDongles(): Promise<common.FetchSkyMapConnectDonglesResponse> {
    const { data } = await this.axios.get<common.FetchSkyMapConnectDonglesResponse>(
      `${this.endpoint}`,
    );
    return data;
  }

  async createDongle(
    params: types.CreateDongleParameters,
  ): Promise<types.CreateSkyMapConnectDongleResponse> {
    const { data } = await this.axios.post<types.CreateSkyMapConnectDongleResponse>(
      `${this.endpoint}`,
      params.body,
    );
    return data;
  }

  async registerDongle(
    params: types.RegisterDongleParameters,
  ): Promise<types.SkyMapConnectDongleRegistrationResponse> {
    const { data } = await this.axios.post<types.SkyMapConnectDongleRegistrationResponse>(
      `${this.endpoint}/${params.path.dongleId}/registration`,
      params.body,
    );
    return data;
  }

  authenticateDongle(
    params: types.AuthenticateDongleParameters,
  ): Promise<types.SkyMapConnectDongleAuthenticationResponse> {
    throw new Error('Method not implemented.');
  }
}
